/** কুরিয়ার অ্যাকাউন্ট ও বুকিং। */
export const shipping = {
    couriers: {
        title: "কুরিয়ার",
        description: "আপনার কুরিয়ার মার্চেন্ট অ্যাকাউন্ট। কী এনক্রিপ্ট করে রাখা হয়, আর কখনো দেখানো হয় না।",
        empty: "এখনো কোনো কুরিয়ার অ্যাকাউন্ট যুক্ত নেই।",
        add: "কুরিয়ার যুক্ত করুন",
        edit: "কুরিয়ার অ্যাকাউন্ট সম্পাদনা",
        name: "নাম",
        provider: "কুরিয়ার",
        keysHint: "কুরিয়ারের মার্চেন্ট প্যানেল থেকে।",
        replaceKeys: "আগের কী রাখতে ফাঁকা রাখুন।",
        key: "কী",
        autoBook: "অর্ডার কনফার্ম হলেই নিজে থেকে বুক করুন",
        isDefault: "ডিফল্ট কুরিয়ার",
        default: "ডিফল্ট",
        autoBookOn: "অটো-বুক",
        archived: "আর্কাইভ করা",
        archive: "আর্কাইভ",
        saved: "কুরিয়ার অ্যাকাউন্ট সংরক্ষিত হয়েছে।",
    },
    credentials: {
        apiKey: "API কী",
        secretKey: "সিক্রেট কী",
        clientId: "ক্লায়েন্ট আইডি",
        clientSecret: "ক্লায়েন্ট সিক্রেট",
        username: "মার্চেন্ট ই-মেইল",
        password: "মার্চেন্ট পাসওয়ার্ড",
        storeId: "স্টোর আইডি",
    },
    providers: {
        steadfast: "স্টেডফাস্ট",
        pathao: "পাঠাও",
        redx: "রেডএক্স",
    },
    status: {
        queued: "বুক হচ্ছে…",
        booked: "বুক হয়েছে",
        failed: "বুকিং ব্যর্থ",
        cancelled: "বাতিল",
    },
    courierStatus: {
        pending: "কুরিয়ারের কাছে",
        in_transit: "পথে",
        on_hold: "হোল্ডে",
        delivered: "ডেলিভারি হয়েছে",
        partially_delivered: "আংশিক ডেলিভারি",
        returned: "ফেরত",
        cancelled: "কুরিয়ার বাতিল করেছে",
        unknown: "অজানা",
    },
    fraud: {
        title: "ফ্রড চেক",
        column: "ঝুঁকি",
        levels: { low: "কম ঝুঁকি", medium: "মাঝারি ঝুঁকি", high: "বেশি ঝুঁকি" },
        blocked: "ব্লক করা নম্বর",
        blockedWarning: "এই নম্বরটি ব্লক করা: {{reason}}",
        advanceRequired: "কনফার্ম করার আগে অগ্রিম নিন।",
        reasons: {
            blocked: "নম্বরটি আপনার ব্লকলিস্টে আছে।",
            new_customer: "নতুন গ্রাহক: এখন পর্যন্ত {{count}}টি অর্ডার ডেলিভারি বা ফেরত হয়েছে।",
            low_success: "এই গ্রাহকের মাত্র {{rate}} অর্ডার ডেলিভারি হয়েছে।",
            medium_success: "এই গ্রাহকের {{rate}} অর্ডার ডেলিভারি হয়েছে।",
            good_history: "এই গ্রাহকের {{rate}} অর্ডার ডেলিভারি হয়েছে।",
            many_cancelled: "{{count}}টি অর্ডার বাতিল হয়েছে।",
            courier_low_success: "কুরিয়ার এই নম্বরের মাত্র {{rate}} পার্সেল ডেলিভারি করতে পেরেছে।",
        },
        own: "আপনার অর্ডার: মোট {{total}}, ডেলিভারি {{delivered}}, ফেরত {{returned}}, বাতিল {{cancelled}}",
        rate: "{{rate}} ডেলিভারি",
        courier: "{{courier}}: {{total}} পার্সেল, ডেলিভারি {{delivered}}, ফেরত {{returned}}",
        courierPending: "কুরিয়ারের কাছে এই নম্বরের ইতিহাস চাওয়া হচ্ছে…",
        block: "নম্বর ব্লক করুন",
        unblock: "আনব্লক",
        blockReason: "কেন ব্লক?",
        blockedDone: "নম্বর ব্লক হয়েছে।",
        unblockedDone: "নম্বর আনব্লক হয়েছে।",
        blockedAt: "ব্লকের তারিখ",
        settingsTitle: "ফ্রড চেক",
        settingsDescription: "নম্বরের ইতিহাস থেকে অর্ডারের ঝুঁকি কীভাবে ঠিক হয়, আর যেসব নম্বর আপনি ব্লক করেছেন।",
        rules: "ঝুঁকির নিয়ম",
        minOrders: "সাফল্যের হার গোনার জন্য দরকারি অর্ডার",
        minOrdersHint: "ডেলিভারি বা ফেরত হওয়া অর্ডার; কম হলে নতুন গ্রাহক।",
        highBelow: "এই ডেলিভারি হারের নিচে বেশি ঝুঁকি (%)",
        mediumBelow: "এই ডেলিভারি হারের নিচে মাঝারি ঝুঁকি (%)",
        cancelledMedium: "অন্তত মাঝারি ঝুঁকির জন্য বাতিল অর্ডার",
        newCustomerLevel: "নতুন গ্রাহকের ঝুঁকি",
        advanceAt: "অগ্রিম চাইবেন যেখান থেকে",
        never: "কখনো না",
        saved: "ঝুঁকির নিয়ম সংরক্ষিত হয়েছে।",
        blocklist: "ব্লক করা নম্বর",
        noneBlocked: "কোনো নম্বর ব্লক করা নেই।",
    },
    cod: {
        title: "COD হিসাব মেলানো",
        description: "কুরিয়ার কত টাকা তুলেছে, কত পরিশোধ করেছে, আর কোথায় মিলছে না।",
        held: "{{count}}টি ডেলিভারি হওয়া পার্সেলের টাকা এখনো পাওয়া যায়নি",
        inTransit: "{{count}}টি পার্সেল পথে",
        payouts: "পেআউট",
        empty: "এখনো কোনো পেআউট ইমপোর্ট হয়নি।",
        mismatches: "অমিল",
        noMismatches: "সব পেআউট লাইন মিলেছে।",
        addsUp: "মিলেছে",
        allMatched: "{{count}}টি সবই মিলেছে",
        notMatched: "{{count}}টি দেখতে হবে",
        posted: "পেআউট পোস্ট হয়েছে; টাকা রেকর্ড হয়েছে এবং পার্সেলগুলো নিষ্পত্তি হয়েছে।",
        voided: "পেআউট বাতিল হয়েছে।",
        post: "পেআউট পোস্ট করুন",
        postTo: "টাকা এসেছে",
        void: "খসড়া বাতিল করুন",
        voidReason: "কেন বাতিল?",
        status: { draft: "খসড়া", posted: "পোস্ট হয়েছে", void: "বাতিল" },
        match: { matched: "মিলেছে", mismatch: "অমিল", unmatched: "আমাদের পার্সেল নয়", duplicate: "ডুপ্লিকেট" },
        columns: {
            reference: "পেআউট",
            paidAt: "পরিশোধের তারিখ",
            total: "পরিশোধিত",
            difference: "পার্থক্য",
            lines: "লাইন",
            status: "অবস্থা",
            parcel: "পার্সেল",
            collected: "সংগ্রহ",
            expected: "প্রত্যাশিত",
            charge: "চার্জ",
            reason: "কারণ",
        },
        import: {
            title: "পেআউট ইমপোর্ট",
            description: "কুরিয়ারের পেআউট স্টেটমেন্ট CSV হিসেবে। পোস্ট করার আগে প্রতিটি লাইন আপনার পার্সেলের সাথে মেলানো হয়।",
            reference: "পেআউট বা ইনভয়েস নম্বর",
            paidAt: "পরিশোধের তারিখ",
            total: "প্রাপ্ত টাকা",
            totalHint: "আপনার ব্যাংক বা ওয়ালেটে যা এসেছে।",
            file: "স্টেটমেন্ট (CSV)",
            fileHint: "কলাম: কনসাইনমেন্ট আইডি বা ইনভয়েস, সংগ্রহের পরিমাণ, এবং চার্জ।",
            read: "{{count}}টি লাইন পড়া হয়েছে।",
            submit: "ইমপোর্ট ও মেলান",
            errors: {
                noColumns: "ফাইলে কনসাইনমেন্ট/ইনভয়েস বা সংগ্রহের পরিমাণের কলাম নেই।",
                noCode: "সারি {{row}}: কনসাইনমেন্ট আইডি বা ইনভয়েস নেই।",
                badAmount: "সারি {{row}}: একটি পরিমাণ পড়া যাচ্ছে না।",
            },
        },
    },
    rtoStatus: {
        pending: "ফেরত স্ক্যান বাকি",
        received: "ফেরত গ্রহণ হয়েছে",
    },
    rto: {
        title: "ফেরত পার্সেল",
        description: "কুরিয়ার যেসব পার্সেল ফেরত আনছে। স্ক্যান করলে অর্ডার ফেরত হবে এবং পণ্য স্টকে ফিরবে।",
        scan: "ট্র্যাকিং কোড স্ক্যান বা টাইপ করুন",
        scanHint: "ট্র্যাকিং কোড, কনসাইনমেন্ট আইডি বা অর্ডার নম্বর।",
        receive: "গ্রহণ করুন",
        received: "অর্ডার {{number}} ফেরত হয়েছে; পণ্য স্টকে ফিরেছে।",
        empty: "কোনো ফেরত পার্সেল অপেক্ষায় নেই।",
        columns: {
            order: "অর্ডার",
            tracking: "ট্র্যাকিং",
            recipient: "গ্রাহক",
            since: "ফেরতের সময়",
        },
    },
    webhook: {
        label: "ওয়েবহুক URL",
        hint: "কুরিয়ারের মার্চেন্ট প্যানেলে বসান, যাতে স্ট্যাটাস সঙ্গে সঙ্গে আসে।",
        shownOnce: "এখনই কপি করুন: এটি একবারই দেখানো হয়। নতুন তৈরি করলে পুরোনোটি বন্ধ হয়ে যায়।",
        create: "ওয়েবহুক URL তৈরি করুন",
        replace: "নতুন ওয়েবহুক URL তৈরি করুন",
        copy: "কপি",
        copied: "ওয়েবহুক URL কপি হয়েছে।",
    },
    sms: {
        title: "কুরিয়ার আপডেটে গ্রাহককে SMS",
        description: "কুরিয়ার এগুলোর কোনোটি জানালে গ্রাহককে SMS যাবে। প্রতি পার্সেলে প্রতিটি একবার।",
        saved: "SMS সেটিংস সংরক্ষিত হয়েছে।",
        statuses: {
            in_transit: "পিকআপ হয়ে পথে আছে",
            on_hold: "ডেলিভারি আটকে আছে",
            delivered: "ডেলিভারি হয়েছে",
            returned: "কুরিয়ার ফেরত দিয়েছে",
        },
    },
    order: {
        title: "কুরিয়ার",
        empty: "এখনো কুরিয়ারে বুক করা হয়নি।",
        book: "কুরিয়ার বুক করুন",
        account: "কুরিয়ার অ্যাকাউন্ট",
        cod: "আদায় করতে হবে",
        codHint: "মোট থেকে অগ্রিম বাদে; দরকার হলে বদলান।",
        note: "কুরিয়ারের জন্য নোট",
        tracking: "ট্র্যাকিং {{code}}",
        consignment: "কনসাইনমেন্ট {{id}}",
        track: "ট্র্যাক করুন",
        lastError: "শেষ ত্রুটি: {{error}}",
        attempts: "{{count}} বার চেষ্টা",
        retry: "আবার চেষ্টা",
        cancel: "বুকিং বাতিল",
        cancelReason: "বুকিং কেন বাতিল করছেন?",
        booked: "বুকিং সারিতে; কুরিয়ারকে কল করা হচ্ছে।",
        retried: "আবার সারিতে দেওয়া হয়েছে।",
        cancelled: "বুকিং বাতিল হয়েছে।",
        notShippable: "কুরিয়ার বুক করতে অর্ডারটি (ডেলিভারি ঠিকানাসহ) কনফার্ম করুন।",
    },
    bulk: {
        book: "কুরিয়ার বুক",
        result: "{{queued}}টি বুকিংয়ের সারিতে, {{failed}}টি বুক হয়নি।",
    },
};
//# sourceMappingURL=shipping.js.map